<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="item-description">
    <div v-if="dataCard" class="item-wrapper">
      <ItemIcon :type="dataCard.source.toLowerCase()" size="sm" :filled="true" />
      <div v-if="dataCard.showDate" class="publication-date-wrapper">
        {{ $t('dates_from') }} {{ formattedShowDate }}
      </div>
      <ItemTimeIcon :types="dataCard.frequency" />
      <ItemLocaIcon :types="dataCard.territories" />
    </div>
    <h2 v-if="dataCard.title" id="box-observer" class="item-main-title">{{ dataCard.title }}</h2>
    <!--h2 v-if="dataCard.description" class="item-main-description">{{ dataCard.description }}</h2-->
    <markdown-it-vue
      class="item-main-description"
      :content="dataCard.description"
      :options="markDownOptions"
    />
    <div class="other-information">
      <div class="information-wrapper">
        <div v-if="dataCard.publishDate" class="card-desc">
          <div class="card-desc-icon calendar" />
          <div class="card-desc-text">{{ formattedPublishDate }}</div>
        </div>
        <div v-if="dataCard.docSource && dataCard.docSource.length > 0" class="card-desc">
          <div class="card-desc-text" v-html="$t('add_font') + ': ' + dataCard.docSource.join(', ')" />
        </div>
      </div>
    </div>
    <div v-if="dataCard.thesaurus" class="group-tesaur">
      <div v-if="isMobile" class="icon-arrow-rotated" />
      <div class="saururs-block">
        <div v-for="thesau in Object.keys(dataCard.thesaurus)" :key="thesau" class="saurus-wrapper">
          <div
            v-for="(saurus, i) in dataCard.thesaurus[thesau]"
            :key="saurus"
            :class="i === dataCard.thesaurus[thesau].length - 1 ? ' bold' : ''"
            class="saurus-op"
          >
            <span>{{ saurus }}</span>
            <span v-if="i !== dataCard.thesaurus[thesau].length - 1"> ></span>
          </div>
        </div>
      </div>
      <div v-if="isMobile" class="icon-arrow" />
    </div>
    <div v-if="documentLink" class="document-link-container">
      <span class="document-default">{{ $t('use_identifier') }}</span>
      <span class="document-link">{{ documentLink }}</span>
    </div>
    <a
      v-if="hasDestination || datastoryLink"
      class="map-prev-container"
      :href="datastoryLink ? datastoryLink : hasDestination"
      target="_blank"
    >
      <span>{{ $t(datastoryLink ? 'datastory_info' : 'map_prev') }}</span>
      <div class="icon-outside" />
    </a>
  </div>
</template>

<script>
import MarkdownItVue from 'markdown-it-vue'
import dayjs from 'dayjs'
import ItemIcon from '../ItemIcon.vue'
import ItemTimeIcon from '../ItemTimeIcon.vue'
import ItemLocaIcon from '../ItemLocaIcon.vue'
const io = new IntersectionObserver(
  entry => {
    if (document.querySelector('#sticky-wrapper')) {
      // Remove 'title-grow' class if observation target is inside viewport
      if (entry[0].intersectionRatio > 0) {
        document.querySelector('#sticky-wrapper').classList.remove('title-grow')
      }
      // Add 'title-grow' class otherwise
      else {
        if (entry[0].boundingClientRect.y < entry[0].rootBounds.y )
          document.querySelector('#sticky-wrapper').classList.add('title-grow')
      }
    }
  },
  {
    rootMargin: '-112px',
  }
)

/**
 * Display diferent icon logo depending on type
 * @example [none]
 */
export default {
  name: 'ItemDescription',
  components: { MarkdownItVue, ItemIcon, ItemTimeIcon, ItemLocaIcon },
  props: {
    /**
     * Item object information getted by api
     */
    dataCard: {
      type: Object,
    },
    documentLink: {
      type: String,
    },
    hasDestination: {},
    datastoryLink: {
      type: String,
    },
  },
  data() {
    return {
      markDownOptions: {
        markdownIt: {
          linkify: true,
        },
        linkAttributes: {
          attrs: {
            target: '_blank',
            rel: 'noopener',
          },
        },
      },
    }
  },
  computed: {
    formattedPublishDate() {
      return dayjs(this.dataCard.publishDate.replace('Z', '')).format('DD/MM/YYYY')
    },
    formattedShowDate() {
      //anual, month, day, trimestral...
      let showDate = this.dataCard.showDate.replace('Z', '')
      if (this.dataCard.typeTime /*&& this.dataCard.typeTime.ca*/ === 'mes')
        return dayjs(showDate).format('MMM YYYY')
      else return dayjs(showDate).format('YYYY')
    },
  },
  mounted() {
    io.observe(document.querySelector('#box-observer'))
  },
  destroyed() {
    io.disconnect()
  },
}
</script>

<style lang="stylus" scoped>
.item-description
  max-width: 100%

  .map-prev-container
    background-color: black
    color: white
    margin-top: vw(35px)
    m-font-size(14, 20)
    align-items: center
    display: flex
    gap: vw(10px)
    padding: vw(11px) vw(22px)
    width: fit-content

    .icon-outside
      transform: rotate(180deg)
      m-icon("arrow-back", 20, white)

  .item-main-title
    m-font-size(32, 44)
    font-weight: 600
    margin-block-start: 0
    margin-block-end: vw(10px)
    color: $base-font-color
    position: sticky
    top: vw(110px)

    .mobile &
      m-font-size(26, 34)

  .item-main-description
    m-font-size(16, 26)
    font-weight: 400
    margin-top: 0

    >>> a
      color: $corporate_color

  .group-tesaur
    align-items: center
    display: flex
    gap: vw(10px)
      
    .saururs-block
      align-items: center
      display: flex
      gap: vw(10px)
      flex-wrap: wrap
      position: relative
      
      .mobile &
        flex-wrap: nowrap
        justify-content: flex-start
        overflow: auto
        z-index: 7
    
    .icon-arrow
      m-icon('chevron-right', 28, $grey-grey)
      
    .icon-arrow-rotated
      m-icon('chevron-right', 28, $grey-grey)
      transform: rotate(180deg)

  .map-prev-container
    background-color: black
    color: white
    margin-top: vw(35px)
    m-font-size(14, 20)
    align-items: center
    display: flex
    gap: vw(10px)
    padding: vw(11px) vw(22px)
    width: fit-content

    .icon-outside
      transform: rotate(180deg)
      m-icon("arrow-back", 20, white)

  .document-link-container
    margin-top: vw(30px)

    .document-default
      m-font-size(14, 22)
      color: $grey
      font-style: italic
      font-weight: 400

    .document-link
      m-font-size(14, 22)
      color: $corporate_color
      font-style: italic
      font-weight: 400
      text-decoration: underline

  .saurus-wrapper
    m-font-size(12, 16)
    border: 1px solid $corporate_color_light
    border-radius: 20px
    color: $grey-dark
    padding: vw(4px) vw(12px)
    display: flex
    gap: vw(4px)
    
    .saurus-op
      display: flex
      gap: vw(4px)

    .bold
      font-weight: 700

    .mobile &
      m-font-size(14, 20)

  .other-information
    align-items: center
    display: flex
    gap: vw(15px)
    margin-top: vw(15px)

    .information-wrapper
      align-items: center
      display: flex
      gap: vw(15px)
      margin-bottom: vw(20px)

      .card-desc
        align-items: center
        display: flex
        gap: vw(5px)
        position: relative

        &:not(:last-child)
          margin-right: vw(15px)

          &:after
            background-color: $bcn-other-grey
            content: ""
            height: vw(12px)
            position: absolute
            right: vw(-15px)
            top: 50%
            transform: translateY(-50%)
            width: 1px

        &.filled
          background-color: #fff
          border-radius: 20px
          box-shadow: 0 4px 80px rgba(#000, 0.05)
          padding: vw(4px) vw(12px)

          .card-desc-text
            margin-top: 0.1em

      .card-desc-icon
        &.calendar
          m-icon("calendar", 20)
          margin-left: vw(-2px)
          margin-top: vw(-1px)

      .card-desc-text
        m-font-size(12, 16)

        .mobile &
          m-font-size(14, 20)

        >>> a
          text-decoration: underline

  .item-wrapper
    align-items: center
    display: flex
    gap: vw(10px)
    margin-bottom: vw(30px)

    .publication-date-wrapper
      m-font-size(12, 16)
      align-items: center
      border: 1px solid $corporate_color_light
      border-radius: 20px
      color: $grey-dark
      display: flex
      height: vw(28px)
      justify-content: center
      margin-left: vw(10px)
      padding: vw(4px) vw(12px)
      padding-top: vw(5px)
</style>